import React, { useState, useEffect } from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { PdfUtils } from '../PdfUtils';
import SuggestionModal from '../Suggestion/SuggestionModal';

const PersonModal = ({ show, selectedPerson, onClose, onExited, onNext, onPrevious, hasNext, hasPrevious }) => {
  const { t } = useTranslation();
  const [showSuggestionModal, setShowSuggestionModal] = useState(false);
  const showModal = showSuggestionModal ? false : show;

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Only handle keyboard navigation when the modal is visible and suggestion modal is not shown
      if (!showModal) return;

      if (event.key === 'ArrowLeft' && hasPrevious) {
        event.preventDefault();
        onPrevious();
      } else if (event.key === 'ArrowRight' && hasNext) {
        event.preventDefault();
        onNext();
      }
    };

    // Add event listener when modal is shown
    if (showModal) {
      window.addEventListener('keydown', handleKeyDown);
    }

    // Cleanup event listener
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [showModal, hasNext, hasPrevious, onNext, onPrevious]);

  return (
    <>
      <Modal
        show={showModal}
        onHide={onClose}
        onExited={onExited}
        centered
        className="d-flex align-items-center"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Informācija")}</Modal.Title>
        </Modal.Header>
        
        <Modal.Body style={{ position: 'relative', padding: '1rem 4rem' }}>
          {/* Previous button - inside modal on the left */}
          <Button
            variant="outline-secondary"
            onClick={onPrevious}
            disabled={!hasPrevious}
            style={{
              position: 'absolute',
              left: '15px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FaChevronLeft />
          </Button>

          {/* Next button - inside modal on the right */}
          <Button
            variant="outline-secondary"
            onClick={onNext}
            disabled={!hasNext}
            style={{
              position: 'absolute',
              right: '15px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FaChevronRight />
          </Button>

          <ListGroup variant="flush">
            {selectedPerson &&
              Object.entries(selectedPerson).map(([key, value]) => {
                const isTable = key === "table";
                const label = isTable ? t("Datubāze") : t(key);
                const translatedValue = isTable
                  ? {
                      1: t("Latviešu strēlnieku 2. brigādes apbalvoto karavīru saraksts"),
                      2: t("Latviešu SS leģionā mobilizēto saraksts"),
                      3: t("Kritušo, bez vēsts pazudušo, ievainoto un gūstā nonākušo latviešu strēlnieku saraksts"),
                      4: t("Zedelgemas (Beļģija) karagūstekņu nometnē ieslodzīto latviešu karavīru saraksts"),
                      5: t("Latviešu strēlnieku bataljonos (pulkos) dienējušo saraksts"),
                      6: t("Kritušo un bez vēsts pazudušo Latviešu SS leģiona karavīru saraksts")
                    }[value] || t("Nav minēts")
                  : value || t("Nav minēts");
                return (
                  <ListGroup.Item key={key}>
                    <strong>{label}:</strong> {translatedValue}
                  </ListGroup.Item>
                );
              })}
          </ListGroup>
        </Modal.Body>
        
        <Modal.Footer className="d-flex justify-content-between align-items-center w-100">
          {/* Left-aligned link */}
          <div>
            <Button
              variant="link"
              className="text-decoration-underline p-0"
              onClick={() => PdfUtils.generatePDF(selectedPerson, t)}
            >
              {t("Lejupielādēt PDF")}
            </Button>
          </div>
          
          {/* Right-aligned buttons */}
          <div className="d-flex gap-2">
            <Button variant="outline-secondary" onClick={() => setShowSuggestionModal(true)}>
              {t("Ieteikt labojumu")}
            </Button>
            <Button variant="dark" onClick={onClose}>
              {t("Aizvērt")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      
      {<SuggestionModal
        show={showSuggestionModal}
        selectedPerson={selectedPerson}
        onClose={() => setShowSuggestionModal(false)}
        onExited={() => setShowSuggestionModal(false)}
      />}
    </>
  );
};

export default PersonModal;